export default "https://assets.egbcdn.net/assets/packs/_/images/cup-table-9b4a96e9411040fc6a9c353a18aac64e.svg";